import { render, staticRenderFns } from "./verification_layout.vue?vue&type=template&id=2e6775d2"
import script from "./verification_layout.vue?vue&type=script&lang=js"
export * from "./verification_layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports